export default "__VITE_ASSET__CsRKHj$X__";